<div class="calendar-symbol mx-3">
    <span class="upper-line">{{calendarDate | date: 'dd'}}</span>
    <span class="lower-line">{{calendarDate | date: 'MMM'}}</span>
    <span *ngIf="showBadge" class="badge bg-danger badge-dot badge-custom"></span>
</div>
